import OrganizationRelation from '../domain/OrganizationRelation';
import { injectable } from 'tsyringe';
import AbstractRestfulHttpService from './AbstractRestfulHttpService';
import ApiService from './ApiService';

@injectable()
export default class OrganizationRelationService extends AbstractRestfulHttpService<OrganizationRelation> {
  public constructor(apiService: ApiService) {
    super(OrganizationRelation, apiService);
  }

  public async getAllByOrganization(
    organizationId: string,
  ): Promise<OrganizationRelation[]> {
    return this.getMany({ organizationId });
  }
}
